import { createSlice } from '@reduxjs/toolkit';
import {
  deleteTreatment,
  fetchTreatments,
  insertTreatments,
  searchTreatments,
  updateTreatment,
} from './actions';
import { Treatment, TreatmentSearchResult } from './models';

export interface TreatmentState {
  treatments: Treatment[];
  loadingTreatments: boolean;
  loadingInsertTreatments: boolean;
  treatmentSearchResults: TreatmentSearchResult[];
  loadingSearchTreatments: boolean;
}

const initialState: TreatmentState = {
  treatments: [],
  loadingTreatments: false,
  loadingInsertTreatments: false,
  treatmentSearchResults: [],
  loadingSearchTreatments: false,
};

const treatmentSlice = createSlice({
  name: 'treatment',
  initialState,
  reducers: {
    clearTreatmentSearchResults: (state) => {
      state.treatmentSearchResults = [];
    },
    clearTreatments: (state) => {
      state.loadingTreatments = true;
      state.treatments = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTreatments.pending, (state) => {
        state.loadingTreatments = true;
      })
      .addCase(fetchTreatments.fulfilled, (state, action) => {
        state.treatments = action.payload;
        state.loadingTreatments = false;
      })
      .addCase(fetchTreatments.rejected, (state) => {
        state.loadingTreatments = false;
      })
      .addCase(searchTreatments.pending, (state) => {
        state.loadingSearchTreatments = true;
      })
      .addCase(searchTreatments.fulfilled, (state, action) => {
        state.treatmentSearchResults = action.payload;
        state.loadingSearchTreatments = false;
      })
      .addCase(searchTreatments.rejected, (state) => {
        state.treatmentSearchResults = [];
        state.loadingSearchTreatments = false;
      })
      .addCase(insertTreatments.fulfilled, (state) => {
        state.loadingInsertTreatments = false;
      })
      .addCase(insertTreatments.pending, (state) => {
        state.loadingInsertTreatments = true;
      })
      .addCase(insertTreatments.rejected, (state) => {
        state.loadingInsertTreatments = false;
      })
      .addCase(updateTreatment.fulfilled, (state, action) => {
        const updatedSymptoms = state.treatments.map((treatment) =>
          treatment.id === action.payload.id ? action.payload : treatment
        );
        state.treatments = updatedSymptoms;
      })
      .addCase(deleteTreatment.fulfilled, (state, action) => {
        state.treatments = state.treatments.filter(
          (treatment) => treatment.id !== action.meta.arg
        );
      });
  },
});

export const { clearTreatmentSearchResults, clearTreatments } =
  treatmentSlice.actions;

export default treatmentSlice.reducer;
